var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          ref: "attachementsTable",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.attachedDocs }
        },
        [
          _c("el-table-column", {
            attrs: { label: "Ημερομηνία", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("i", { staticClass: "el-icon-time" }),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(_vm._s(scope.row.date))
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-button", {
                      attrs: {
                        size: "mini",
                        type: "primary",
                        round: "",
                        icon: "el-icon-download"
                      },
                      on: {
                        click: function($event) {
                          _vm.downloadPdf(scope.$index, scope.row)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("el-button", {
                      attrs: {
                        size: "mini",
                        type: "primary",
                        round: "",
                        icon: "el-icon-view"
                      },
                      on: {
                        click: function($event) {
                          _vm.viewPdf(scope.$index, scope.row)
                        }
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Δικαιολογητικό" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.calcType(scope.row.type, scope.row.name)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            staticClass: "hidden-sm-and-down",
            attrs: { label: "Σχόλιο Χρήστη" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.applicantComment) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm.role === "prechecker"
            ? _c("el-table-column", {
                staticClass: "hidden-sm-and-down",
                attrs: { label: "Σχόλιο Προελέγχου" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            autosize: { minRows: 2, maxRows: 4 },
                            placeholder: ""
                          },
                          on: {
                            change: function($event) {
                              _vm.commentChanged(scope.$index, scope.row)
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.addTextToDoc(scope.$index, scope.row)
                            }
                          },
                          model: {
                            value: scope.row.precheckerComment,
                            callback: function($$v) {
                              _vm.$set(scope.row, "precheckerComment", $$v)
                            },
                            expression: "scope.row.precheckerComment"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.role === "prechecker"
            ? _c("el-table-column", {
                attrs: { label: "ΟΚ", width: "50" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-checkbox", {
                          on: {
                            change: function($event) {
                              _vm.commentChanged(scope.$index, scope.row)
                            }
                          },
                          model: {
                            value: scope.row.precheckerChecked,
                            callback: function($$v) {
                              _vm.$set(scope.row, "precheckerChecked", $$v)
                            },
                            expression: "scope.row.precheckerChecked"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.role === "prechecker"
        ? _c(
            "el-checkbox",
            {
              staticClass: "select-all-docs",
              on: { change: _vm.handleSelectAllChanged },
              model: {
                value: _vm.checkAll,
                callback: function($$v) {
                  _vm.checkAll = $$v
                },
                expression: "checkAll"
              }
            },
            [_vm._v("Επιλογή όλων\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "el-form",
        { attrs: { inline: true, "label-width": "180px" } },
        [
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.userComment != "",
                  expression: 'userComment != ""'
                }
              ],
              attrs: { label: "Σχόλιο από τον αιτούντα" }
            },
            [_vm._v("\n      " + _vm._s(_vm.userComment) + "\n    ")]
          ),
          _vm._v(" "),
          _c("p"),
          _vm._v(" "),
          _vm.showCommentsToApplicantField
            ? _c(
                "el-form-item",
                { attrs: { label: "Σχόλιο για τον αιτούντα" } },
                [
                  _c("vue-editor", {
                    staticClass: "propcolor",
                    attrs: { "editor-toolbar": _vm.customToolbar },
                    on: { "text-change": _vm.generalCommentChanged },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.addText($event)
                      }
                    },
                    model: {
                      value: _vm.generalCommentWork,
                      callback: function($$v) {
                        _vm.generalCommentWork = $$v
                      },
                      expression: "generalCommentWork"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.addTextdialogVisible
            ? _c(
                "el-dialog",
                {
                  attrs: {
                    title: "Συνήθεις Προτάσεις",
                    visible: _vm.addTextdialogVisible,
                    width: "90%"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.addTextdialogVisible = $event
                    }
                  }
                },
                [
                  _vm._l(_vm.recommendations, function(recom) {
                    return _c(
                      "div",
                      {
                        key: recom.id,
                        attrs: {
                          value: { id: recom.id, name: recom.description },
                          label: recom.description
                        }
                      },
                      [
                        _c("div", [
                          _c("label", [
                            _c("input", {
                              attrs: { type: "checkbox" },
                              domProps: {
                                value: recom.description,
                                checked: false
                              },
                              on: {
                                change: function($event) {
                                  _vm.toggleText(
                                    recom.id,
                                    recom.description,
                                    $event.target.checked
                                  )
                                }
                              }
                            }),
                            _vm._v(" " + _vm._s(recom.description))
                          ])
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        { on: { click: _vm.cancelTextToComment } },
                        [_vm._v("Άκυρο")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.addTextToComment }
                        },
                        [_vm._v("Επιβεβαίωση")]
                      )
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c487ebda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c487ebda","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AttachedDocuments.vue
// module id = null
// module chunks = 